import { render, staticRenderFns } from "./new-policy.vue?vue&type=template&id=bb8ccaea&scoped=true"
import script from "./new-policy.vue?vue&type=script&lang=js"
export * from "./new-policy.vue?vue&type=script&lang=js"
import style0 from "./new-policy.vue?vue&type=style&index=0&id=bb8ccaea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8ccaea",
  null
  
)

export default component.exports